export default "__VITE_ASSET__04ffe8f4__"